import { UserAction } from '../actions/user';
import { ActionType } from '../action-types';
import { ActiveEmployeeInvite, User, UserModules } from '@vyce/core/src/types';

export interface UserState extends User {
  employeeActiveInvites: ActiveEmployeeInvite[];
  inviteModules: UserModules;
}

const DEFAULT_MODULES: UserModules = { pay: false, teams: false, time: false };

const initialState: UserState = {
  uuid: '',
  first_name: '',
  last_name: '',
  email: '',
  employeeActiveInvites: [],
  inviteModules: DEFAULT_MODULES,
};

const reducer = (state: UserState = initialState, action: UserAction): UserState => {
  switch (action.type) {
    case ActionType.SET_USER_DATA:
      return {
        ...state,
        ...action.payload,
        employeeActiveInvites: state.employeeActiveInvites,
        inviteModules: state.inviteModules,
      };
    case ActionType.SET_EMPLOYEE_ACTIVE_INVITES:
      return {
        ...state,
        employeeActiveInvites: action.payload,
      };
    case ActionType.SET_INVITE_MODULES:
      return {
        ...state,
        inviteModules: action.payload,
      };
    case ActionType.SET_INITIAL_USER_STATE:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
